import reportErrorToFaro from './reportErrorToFaro';

const appendTag = (type: 'script' | 'link', props: Partial<HTMLScriptElement | HTMLLinkElement>, appendTo: 'head' | 'body' = 'head') =>
  new Promise((res, rej) => {
    try {
      const element = document.createElement(type);

      Object.assign(element, props);
      element.onload = () => {
        res(element);
      };
      if (props.onerror) {
        element.onerror = props.onerror;
      }
      document[appendTo].appendChild(element);
    } catch (error: unknown) {
      reportErrorToFaro(error, 'appendTag');
      rej(error);
    }
  });

export default {
  addLink: (href: string, props?: Partial<HTMLLinkElement>) =>
    appendTag('link', {
      ...props,
      href,
      rel: 'stylesheet',
      type: 'text/css',
    }),
  addScript: (src: string, props?: Partial<HTMLScriptElement>) =>
    appendTag('script', {
      ...props,
      src,
    }),
  addScriptToBody: (src: string, props?: Partial<HTMLScriptElement>) =>
    appendTag(
      'script',
      {
        ...props,
        src,
      },
      'body'
    ),
};
